// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__cksYJ","info":"Panel_info__8lrtC","btns":"Panel_btns__rz2DL","button":"Panel_button__M-d7P"};